import React, { createContext, useContext, type ReactNode } from 'react';

import { Badge } from 'features/catalog/useBadges';
import { FeedUpdate } from 'features/feed/useFeedUpdates';
import { Profile, RawSubmission } from 'features/profiles/useProfiles';
import { ContributorIds } from 'features/catalog/badge-contributors';

/** Shared catalog + roster + feed — computed once in App, read via useTalosData(). */
export interface TalosData {
  profilesMap: Map<string, Profile>;
  rankedProfiles: Profile[];
  badgesMap: Map<string, Badge>;
  feedUpdates: FeedUpdate[];
  submissionsByEmail: Map<string, RawSubmission[]>;
  contributorIndex: Map<string, ContributorIds>;
}

const TalosDataContext = createContext<TalosData | null>(null);

export function TalosDataProvider({ value, children }: { value: TalosData; children: ReactNode }) {
  return <TalosDataContext.Provider value={value}>{children}</TalosDataContext.Provider>;
}

export function useTalosData(): TalosData {
  const ctx = useContext(TalosDataContext);
  if (!ctx) throw new Error('useTalosData must be used within TalosDataProvider');
  return ctx;
}
